// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","314":"orderdetail","377":"purchases","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"77606bbf","179":"2efd68f1","206":"175b5fe7","207":"b535dae7","314":"f124115b","330":"45113e2d","377":"efef9e35","594":"bdc0606c","998":"851d7745"}[chunkId] + ".js";
};